<template>
  <Drawer
    :id="drawerId"
    title="Project / Job Sync"
  >
    <v-card flat>
      <v-card-text>
        <v-select
          v-model="selectedProjectId"
          label="Select a target project"
          outlined
          item-value="id"
          :items="projects"
          hide-details
          :menu-props="{ maxHeight: '80%', 'offset-y': true }"
        >
          <template #[`selection`]="{ item }">
            <div class="d-flex align-center">
              <img
                :src="item.previewUrl"
                style="max-height: 30px; max-width: 100px"
              />
              <span>{{ item.name }}</span>
            </div>
          </template>
          <template #[`item`]="{ active, item, attrs, on }">
            <div
              class="d-flex align-center py-3 border-light border-b w-full"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                v-if="item.id === jobProjectId"
                color="mcsprimary"
                style="position: absolute; top: 1px; left: 15px"
              >
                star
              </v-icon>
              <img
                :src="item.previewUrl"
                style="width: 180px; max-height: 150px"
              />
              <div class="body-2 ml-3">
                <div class="font-weight-bold">
                  {{ item.id }}
                </div>
                <div>{{ item.name }}</div>
                <div>{{ item.modified | normalDateWithTime }}</div>
              </div>
            </div>
          </template>
        </v-select>
        <v-radio-group
          v-model="syncDirection"
          mandatory
        >
          <v-radio
            label="Sync latest project to job"
            value="project-to-job"
          />
          <v-radio
            label="Sync job to project"
            value="job-to-project"
          />
        </v-radio-group>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="syncing"
          :disabled="!syncEnabled"
          @click="sync"
        >
          Sync
        </v-btn>
      </div>
    </template>
  </Drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import Drawer from '@/components/layout/Drawer';
import enums from '../../../helpers/enums';
export default {
  name: 'PrintJobProject',

  components: { Drawer },

  data() {
    return {
      syncing: false,
      job: {},
      projects: [],
      selectedProjectId: 0,
      drawerId: enums.DRAWERS.PRINT_JOB_SYNC,
      syncDirection: ''
    };
  },

  computed: {
    drawerOpenedAt() {
      return this.$store.state.drawers.lastOpenedAt;
    },
    ...mapGetters({
      initialData: 'drawers/data'
    }),
    jobProjectId() {
      return this.job.userProjectId;
    },
    syncEnabled() {
      return this.selectedProjectId !== 0;
    }
  },

  watch: {
    async drawerOpenedAt() {
      if (this.drawerId === this.$store.getters['drawers/topDrawer']?.id) {
        this.job = cloneDeep(this.initialData(this.drawerId).job);
        this.projects = (
          await this.$http.get(`users/getSimpleProjects?userId=${this.job.userInfoId}`)
        ).data;
      }
    }
  },

  methods: {
    sync() {
      this.syncing = true;
      var payload = {
        orderId: this.job.orderId,
        jobId: this.job.jobId,
        userProjectId: this.selectedProjectId
      };
      var action = '';
      if (this.syncDirection === 'project-to-job') {
        action = 'orders/syncProjectToJob';
      } else if (this.syncDirection === 'job-to-project') {
        action = 'orders/syncJobToProject';
      }
      this.$store
        .dispatch(action, payload)
        .then(() => {
          this.$store.commit('drawers/GO_BACK');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.syncing = false;
        });
    }
  }
};
</script>
